<template>
  <div class="categories-select-field">
    <v-select
      :value="value"
      :items="categories"
      attach
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      multiple
      outlined
      item-text="name"
      item-value="id"
      :loading="loading"
      :disabled="loading"
      @input="syncValue"
    ></v-select>
  </div>
</template>

<script>
  import _ from 'lodash'
  import md5 from 'md5'
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    name: 'CategoriesSelectFields',
    components: { },
    mixins: [rules],
    data () {
      return {
      }
    },
    props: {
      label: {
        type: String,
        default: 'Категории',
      },
      value: {
        type: Array,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        categories: 'categories/getCategoriesList',
      }),
      showEmptyText () {
        return this.emptyText && _.isEmpty(this.value) && !this.loading
      },
      hint () {
        return this.showEmptyText ? this.emptyText : null
      },
    },
    methods: {
      syncValue (value) {
        this.search = ''
        this.$emit('input', value)
      },
    },
    created () {
      if (!this.categories || this.categories.length === 0) {
        this.$store.dispatch('categories/fetchCategoriesList')
      }
    },
  }
</script>

<style lang="less" scoped>
.categories-select-field {
  ::v-deep {
    .v-text-field .v-label--active {
      transform: translateY(-25px) scale(0.75);
    }
  }
}
</style>
